import { demuxTsSegment } from './mpegTsDemuxer';
import { downmixAacChannels, type FlacDownmixConfig, type TransmuxUtilityOps } from './transmuxUtility';
import { PcmSampleFetcher } from './pcmSampleFetcher';
import { invariant } from '../util/invariant';
import { encodeToFlacInFragmentedMp4Buffers } from '../flac/flacInMp4';
import type { FragmentedMp4Buffers } from '../mp4/fragmentedMp4Types';

export class AudioOnlyTransmuxer implements TransmuxUtilityOps {

  private pcmSampleFetcher = new PcmSampleFetcher();
  private firstPts: number | undefined;

  transmuxSegment(m2tsSegment: Uint8Array, info: Record<string, any>, flacDownmixConfig: FlacDownmixConfig | null, onlyUseLastAacPacket: boolean): FragmentedMp4Buffers {
    invariant(flacDownmixConfig !== null, 'AudioOnlyTransmuxer.transmuxSegment() should always be invoked with a non null FlacDownmixConfig');
    const encodedData = demuxTsSegment(m2tsSegment, false);
    if (this.firstPts === undefined) {
      this.firstPts = encodedData.encodedAudioData[0]!.frames[0]!.pts;
    }
    if (onlyUseLastAacPacket) {
      for (const audioData of encodedData.encodedAudioData) {
        const nFrames = audioData.frames.length;
        audioData.frames.splice(0, nFrames - 1);
      }
    }

    const pcmFloat32Channels = this.pcmSampleFetcher.getDecodedPcmFloat32Channels(encodedData);
    const pcmSamples = downmixAacChannels(pcmFloat32Channels, flacDownmixConfig);

    const pts = encodedData.encodedAudioData[0]!.frames[0]!.pts;
    // An mp4 fragment needs to have baseMediaDecodeTime set to the presentation timestamp
    // of its first sample. Since we have PTS values in ts time base which is always 90000,
    // we need to convert the PTS offset from the start of the first segment into the time
    // base used by the fragment which is the sample rate in Hz.
    const baseMediaDecodeTime = pcmFloat32Channels.sampleRateInHz * (pts - this.firstPts) / 90000;
    return encodeToFlacInFragmentedMp4Buffers(baseMediaDecodeTime, pcmSamples, 2, pcmFloat32Channels.sampleRateInHz, true, false);
  }

}
